import { Component, OnInit } from '@angular/core';
import { LifeCycles, registerApplication } from 'single-spa';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { PlatformCommunicatorAuthService } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { PlatformEndpointService } from 'src/app/shared/shared.module';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import * as singleSpa from 'single-spa';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';

@Component({
  selector: 'app-micro-evidente-master',
  templateUrl: './micro-evidente-master.component.html',
  styleUrls: ['./micro-evidente-master.component.scss'],
})
export class MicroEvidenteMasterComponent implements OnInit {
  authSso: any;
  controlFlow: any;
  functions: any;

  constructor(
    private headerService: HeaderService,
    private authService: PlatformCommunicatorAuthService,
    private navigationService: NavigationService,
    private loaderService: LoaderService,
    private abreCuentasService: AbreCuentasService,
    private endpointService: PlatformEndpointService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private validationHelperService: ValidationHelperService,
    private incomesService: IncomesService,
    private postValidateService: PostValidateService,
  ) {
    this.headerService.show(false, false, true),
    this.authSso = {
      ally_name: this.abreCuentasService.getproductSelected().es,
      session_id: this.authService.getSessionId(),
      token: this.authService.getSSOInformation().accessToken,
      transaction_id: this.abreCuentasService.getTransactionId(),
      product_code: this.abreCuentasService.getproductSelected().product_code,
      channelID: this.channelCommunicatorService.getChannelId(),
    };

    this.controlFlow = {
      nextStep: () => {
        this.loaderService.forceHide();
        this.navigationService.nextStep();
      },
      previousStep: () => this.navigationService.previousStep(),
    };

    this.functions = {
      customerDataEvidente: (value: any) => this.abreCuentasService.setCustomerData(value),
      otherSimulationData: (value: any) => this.abreCuentasService.setOtherEvidentenData(value),
      isPepData: (value: any) => this.abreCuentasService.setFiProperty('IsPEP', value),
      downloadPdf: (value: any) => this.channelCommunicatorService.getImpl().openPdf(value),
      exitApp: () => this.channelCommunicatorService.getImpl().redirectToLoginView(),
      officeRedirect: () => this.channelCommunicatorService.getImpl()
        .openPage(this.endpointService.URLS.BRANCH_OFFICE, 5, this.abreCuentasService.getPostlogin()),
      backpage: () => this.channelCommunicatorService.getImpl().redirectToLoginView(),
      getProductsSelects: () => this.abreCuentasService.getProductsSelects(),
      getproductSelected: () => this.abreCuentasService.getproductSelected(),
      setProductsSelects: (value: any) => this.abreCuentasService.setProductsSelects(value),
      changeToPhase: (value: any) => this.navigationService.changeToPhase(value),
      loadApplicationFlow: async (value: any) => await this.navigationService.loadApplicationFlow(value),
      getInfoClient: (value: any) => this.abreCuentasService.setDataMFE(value),
      setCustomerDataClient: () => this.validationHelperService.setCustomerDataClient(),
      setCustomerData: (value: any) => this.abreCuentasService.setCustomerData(value),
      setCurrentStep: (value: any) => this.navigationService.setCurrentStep(value),
      switchFunction: (value: any) => this.postValidateService.switchFunction(value),
      setListClientProduct: (value: any) => this.abreCuentasService.setListClientProduct(value),
      setClientProduct: (value: any) => this.abreCuentasService.setClientProduct(value),
      getIsLogin: () => this.abreCuentasService.getPostlogin(),
      getDocumentInfo: () => this.abreCuentasService.getDocumentInfo(),
      setMultiView: (value: any) => this.abreCuentasService.setMultiView(value),
      setproductSelected: (value: any) => this.abreCuentasService.setproductSelected(value),
      callIncomes: () => this.incomesService.callIncomes(),
      getPhase: (value1: any, value2: any) => this.navigationService.getPhase(value1, value2),
      goToFlowSteps: (value1: any, value2: any, value3: any) => this.navigationService.goToFlowSteps(value1, value2, value3),
      flagGreyZone: (flag: boolean) => this.abreCuentasService.setflagGreyZone(flag),
    };
  }

  ngOnInit() {
    const status = singleSpa.getAppStatus('evidente');
    status === 'MOUNTED' ? singleSpa.unloadApplication('evidente') :
      registerApplication({
        name: 'evidente',
        app: (): Promise<LifeCycles> => System.import(this.endpointService.MICROFRONTENDS.EVIDENTE),
        activeWhen: '/',
        customProps: {
          ssoProps: this.authSso,
          controls: this.controlFlow,
          loader: this.loaderService,
          functions: this.functions,
        },
      });
  }

  nextValidate() {
    let products = this.abreCuentasService.getProductsSelects();
    if (products.find(fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) || products.find(fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep('200');
    }
  }
}
